import type { InfluencerVoucher } from '@/marketing/models/voucher';

/** The campaign column's text: the campaign name, or which kind of code it is when there is none to show. */
export function voucherCampaignLabel(voucher: Pick<InfluencerVoucher, 'campaignId' | 'campaignName'>): string {
  if (!voucher.campaignId) return 'Personal code';
  return voucher.campaignName ?? 'Unknown campaign';
}
